export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
  'login.form.title': 'Sign in',
  'login.form.hint.user': 'Login',
  'login.form.hint.password': 'Password',
  'login.form.checkbox.remember-me': 'Remember me',
  'login.form.button.sign-in': 'Sign in',
  'login.form.message.invalid-user-credentials': 'Login or password is incorrect',
  'login.form.message.account-temporarily-locked': 'Your account is temporarily locked, come back in 5 minutes',
  'login.form.message.user-required': 'Enter an login',
  'login.form.message.password-required': 'Enter an Password',
  'login.form.button.forgot-password': 'Forgot password?',
  'error.mfa-required.title': 'Set up two-factor authentication',
  'error.mfa-required.message1': 'Two-factor authentication (2FA) is required to protect your account.',
  'error.mfa-required.message2': 'You will be redirected to your account settings in the Online Dashboard. Enable 2FA, follow the setup instructions, and then return here.',
  'error.mfa-required.learnMore': 'Learn more about 2FA',
  'error.mfa-required.continue': 'Continue',
  'error.root-admin-login.title': 'Error 403 – forbidden',
  'error.root-admin-login.message': 'You are logged in as a Read-Only Administrator. To access Web Recovery console please log in as a customer tenant user or administrator instead',
  'error.server-busy.message': 'The server is busy, please try again later.',
  'error.network-connection.title': 'Network connection error',
  'error.network-connection.message': 'Check your internet connection and try again.',
  'error.internal-server-error.title': 'Internal server error',
  'error.internal-server-error.message': 'To resolve the error, contact support with the error details:',
  'error.internal-server-error.copy.button': 'Copy'
};
